import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=289888fc&scoped=true&"
import script from "./Version.vue?vue&type=script&lang=ts&"
export * from "./Version.vue?vue&type=script&lang=ts&"
import style0 from "./Version.vue?vue&type=style&index=0&id=289888fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289888fc",
  null
  
)

export default component.exports